// Varme Luxe — Header: alleen licht op hero-pagina's
(function () {
  // Controleer of de animated hero op deze pagina staat
  if (document.querySelector('.varme-hero')) {
    document.body.classList.add('varme-has-hero');
  }
})();
